import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1.5 4.59875V3.88067C1.49947 3.30747 1.73629 2.75757 2.1583 2.35208C2.58032 1.94658 3.15292 1.71875 3.75 1.71875H20.25C20.8471 1.71875 21.4197 1.94658 21.8417 2.35208C22.2637 2.75757 22.5005 3.30747 22.5 3.88067V4.60067",
			stroke: "#262626",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 1.71875V23.3188",
			stroke: "#262626",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 23.3203H16.5",
			stroke: "#262626",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2225%22%20viewBox%3D%220%200%2024%2025%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M1.5%204.59875V3.88067C1.49947%203.30747%201.73629%202.75757%202.1583%202.35208C2.58032%201.94658%203.15292%201.71875%203.75%201.71875H20.25C20.8471%201.71875%2021.4197%201.94658%2021.8417%202.35208C22.2637%202.75757%2022.5005%203.30747%2022.5%203.88067V4.60067%22%20stroke%3D%22%23262626%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M12%201.71875V23.3188%22%20stroke%3D%22%23262626%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.5%2023.3203H16.5%22%20stroke%3D%22%23262626%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";
